"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payroll = void 0;
const bn_js_1 = __importDefault(require("bn.js"));
const constants_1 = require("../../constants");
class Payroll {
    constructor(famineTs, lastCheckpointTs, rewardsRatePerSecond, rewardsPerTokenStored, tokenDecimals, totalTokensDeposited) {
        this.famineTs = famineTs;
        this.lastCheckpointTs = lastCheckpointTs;
        this.rewardsRatePerSecond = rewardsRatePerSecond;
        this.rewardsPerTokenStored = rewardsPerTokenStored;
        this.tokenDecimals = tokenDecimals;
        this.totalTokensDeposited = totalTokensDeposited;
    }
    /**
     * Calculates the amount of tokens that this user can receive.
     * @param current_ts
     * @returns
     */
    calculateWagesPerToken(current_ts) {
        if (this.totalTokensDeposited.isZero()) {
            return this.rewardsPerTokenStored;
        }
        const lastTimeRewardsApplicable = bn_js_1.default.min(current_ts, this.famineTs);
        const timeWorked = bn_js_1.default.max(constants_1.ZERO, lastTimeRewardsApplicable.sub(this.lastCheckpointTs));
        const wage = timeWorked.mul(this.rewardsRatePerSecond);
        const preciseWage = wage
            .mul(this.decimalPrecision())
            .div(this.totalTokensDeposited);
        return this.rewardsPerTokenStored.add(preciseWage);
    }
    /**
     * Calculates the amount of tokens that this user can claim.
     * @param currentTs
     * @param tokensDeposited
     * @param wagesPerTokenPaid
     * @param wagesEarned
     * @returns
     */
    calculateWagesEarned(currentTs, tokensDeposited, wagesPerTokenPaid, wagesEarned) {
        const netNewWages = this.calculateWagesPerToken(currentTs).sub(wagesPerTokenPaid);
        const earnedWages = tokensDeposited
            .mul(netNewWages)
            .div(this.decimalPrecision());
        return earnedWages.add(wagesEarned);
    }
    decimalPrecision() {
        return constants_1.BASE_TEN.pow(this.tokenDecimals);
    }
}
exports.Payroll = Payroll;
//# sourceMappingURL=payroll.js.map